import * as React from "react"

const SakuraSpinner = (props) => (
    <div className="loading-container" style={!props.open ? {display: "none"} : {}}>
        <img src="/TokyoLifeIcon.png" width="50" height="50" className="svg-spin" alt="Loading..."/>
        <span>Xin vui lòng đợi</span>
    </div>
)
export default SakuraSpinner
